 angular
   .module('vppApp')
   .factory('ServerNodeIntercept', ServerNodeIntercept);
 ServerNodeIntercept.$inject = ['$rootScope', '$q', 'ServerNodeStore'];

 function ServerNodeIntercept($rootScope, $q, ServerNodeStore) {

   return {
     response: function (response) {
       var debugNode = (response.data && response.data.metadata && response.data.metadata.vppNode) || debugNode;
       if (debugNode) {
         ServerNodeStore.addNode(response.data.metadata);
       }

       return response || $q.when(response);
     },
     responseError: function (rejection) {
       var debugNodeError = (rejection.data && rejection.data.metadata && rejection.data.metadata.vppNode) || debugNodeError;

       if (debugNodeError) {
         ServerNodeStore.addNode(rejection.data.metadata);
       }
       return $q.reject(rejection);
     }

   };
 }